import React from 'react'

function FilterIcon(): JSX.Element {
  return (
    <svg
      className="filter-icon"
      viewBox="0 0 64 64"
      x="0px"
      y="0px"
    >
      <path d="M8 8l18.667 21.333v21.333l10.667 5.333v-26.667l18.667-21.333h-24z" />
    </svg>
  )
}

export default FilterIcon
